document.addEventListener('DOMContentLoaded',function(){if(location.pathname==='/products/personalized-storybook-test'){document.querySelectorAll('a[href*="/apps/little-wonder/customize?product=15396273357029"]').forEach(function(link){link.textContent='Personalize their book →';});}});
document.addEventListener('DOMContentLoaded',function(){if(location.pathname==='/products/create-your-own-story-personalized-book'){document.querySelectorAll('a[href*="/apps/little-wonder/customize?product=15396661068005"]').forEach(function(link){link.href='/apps/little-wonder/story?product=15396661068005&variant=67606133113061';link.addEventListener('click',function(){const input=document.querySelector('form[action*="/cart/add"] input[name="id"]');const variant=input&&input.value;const url=new URL(link.href,location.origin);if(variant)url.searchParams.set('variant',variant);link.href=url.pathname+url.search;});link.textContent='Create my story →';});}});
document.addEventListener('click',function(e){const cart=e.target.closest('[data-tb-cart]');if(cart){location.href='/cart';return}const menu=e.target.closest('[data-tb-menu]');if(menu){const nav=menu.closest('.tb-demo').querySelector('.mobile-nav');nav.hidden=!nav.hidden;menu.setAttribute('aria-expanded',String(!nav.hidden));return}const ex=e.target.closest('[data-tb-excerpt]');if(ex){const root=ex.closest('.sample-reader');root.querySelectorAll('[data-tb-excerpt]').forEach(b=>b.setAttribute('aria-pressed',String(b===ex)));root.querySelector('#excerpt-copy').innerHTML=ex.dataset.tbExcerpt==='1'?'<div class="eyebrow">Words from the heart</div><h3>Dear Andrew,</h3><blockquote>May you always be curious, a little brave, and wonderfully you.<br><br>With all our love.</blockquote>':'<div class="eyebrow">The Birthday Adventure</div><h3>An invitation to adventure.</h3><blockquote>On the morning of <mark>Andrew’s</mark> birthday, a tiny golden envelope arrived.<br><br>“An adventure is waiting,” it said.</blockquote>';return}const info=e.target.closest('[data-tb-info]');if(info){let d=document.querySelector('.tb-demo-dialog');if(!d){d=document.createElement('dialog');d.className='tb-demo-dialog';document.body.appendChild(d)}const content={shipping:['Delivery & returns','Production, delivery estimates and returns for personalized books will be confirmed before orders are accepted.'],privacy:['Photo privacy','Only upload photos you have permission to use. This theme does not generate illustrations from uploaded photos.'],concept:['About TaleBlossom','Stories that begin with them. Keepsakes that begin with you. Personalized stories for ages 0–15.']};const pair=content[info.dataset.tbInfo]||content.concept;d.innerHTML='<button aria-label="Close">×</button><h2>'+pair[0]+'</h2><p>'+pair[1]+'</p>';d.querySelector('button').onclick=()=>d.close();d.showModal()}});
document.addEventListener('click',function(e){
  const personal=e.target.closest('[data-tb-personalize]');
  if(personal){
    const root=personal.closest('.tb-personalization-block');
    const status=root.querySelector('[data-tb-app-status]');
    personal.disabled=true; status.hidden=false; status.textContent='Checking your storybook…';
    const base=(window.Shopify?.routes?.root||'/')+'apps/little-wonder';
    fetch(base+'?product='+encodeURIComponent(personal.dataset.product),{headers:{Accept:'application/json'},cache:'no-store'})
      .then(async response=>{if(!response.ok)throw new Error('connection'); return response.json();})
      .then(data=>{
        if(!data.book){status.textContent='This storybook is being prepared. Personalization will open when its sample pages are ready.';return;}
        const url=new URL(base+'/customize',window.location.origin);
        url.searchParams.set('product',personal.dataset.product);
        const variant=document.querySelector('[name="id"][form]')?.value||document.querySelector('form[action*="/cart/add"] [name="id"]')?.value||personal.dataset.variant;
        url.searchParams.set('variant',variant);
        url.searchParams.set('variants',root.querySelector('[data-tb-variants]').textContent);
        url.searchParams.set('currency',window.Shopify?.currency?.active||'USD');
        window.location.assign(url.href);
      })
      .catch(()=>{status.textContent='We could not connect to personalization. Please try again shortly.';})
      .finally(()=>{personal.disabled=false;});
    return;
  }
  const zoom=e.target.closest('[data-tb-zoom]');
  if(zoom){let dialog=document.querySelector('.tb-image-dialog');if(!dialog){dialog=document.createElement('dialog');dialog.className='tb-demo-dialog tb-image-dialog';dialog.style.maxWidth='1050px';dialog.style.width='calc(100% - 36px)';dialog.innerHTML='<button aria-label="Close">×</button>';const image=zoom.querySelector('img').cloneNode(true);image.style.width='100%';image.style.height='auto';dialog.appendChild(image);document.body.appendChild(dialog);dialog.querySelector('button').onclick=()=>dialog.close();}dialog.showModal();}
});

(function () {
  function mountUploadDock() {
    const source = document.querySelector('little-wonder-personalizer [data-upload-image]');
    const existing = document.querySelector('[data-tb-upload-dock]');
    if (!source || !location.pathname.includes('/products/')) { if (existing) existing.remove(); document.body.classList.remove('tb-has-upload-dock'); return; }
    if (existing && existing.sourceLink === source) return;
    if (existing) existing.remove();
    const dock = document.createElement('div');
    dock.className = 'tb-upload-dock';
    dock.setAttribute('data-tb-upload-dock', '');
    dock.setAttribute('role', 'region');
    dock.setAttribute('aria-label', 'Create your personalized book');
    dock.sourceLink = source;
    const inner = document.createElement('div');
    inner.className = 'tb-upload-dock__inner';
    const title = document.createElement('span');
    title.className = 'tb-upload-dock__title';
    title.textContent = document.querySelector('.product__title h1, h1.product__title, .product__title')?.textContent.trim() || 'A story made for them';
    const button = document.createElement('a');
    button.className = 'button tb-upload-dock__button';
    inner.append(title, button);
    dock.append(inner);
    document.body.append(dock);
    function sync() {
      button.textContent = source.textContent.trim();
      button.href = source.href;
      dock.hidden = source.hidden;
      document.body.classList.toggle('tb-has-upload-dock', !dock.hidden);
      const preview = document.getElementById('preview-bar-iframe');
      const offset = preview && preview.getBoundingClientRect().bottom >= window.innerHeight - 2 ? preview.getBoundingClientRect().height : 0;
      dock.style.bottom = offset + 'px';
      document.body.style.setProperty('--tb-upload-dock-space', (dock.hidden ? 0 : dock.getBoundingClientRect().height + offset) + 'px');
    }
    button.addEventListener('click', function (event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      source.click();
    });
    const observer = new MutationObserver(sync);
    observer.observe(source, { attributes: true, childList: true, subtree: true });
    const resize = new ResizeObserver(sync);
    resize.observe(dock);
    const preview = document.getElementById('preview-bar-iframe');
    if (preview) resize.observe(preview);
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:unload', function cleanup() {
      if (source.isConnected) return;
      observer.disconnect(); resize.disconnect(); window.removeEventListener('resize', sync);
      dock.remove(); document.body.classList.remove('tb-has-upload-dock');
      document.removeEventListener('shopify:section:unload', cleanup);
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountUploadDock);
  else mountUploadDock();
  document.addEventListener('shopify:section:load', mountUploadDock);
})();

(function () {
  function makeSamplePagesClickable() {
    document.querySelectorAll('.lw-sample-book__page').forEach(function (page) {
      page.tabIndex = 0;
      page.setAttribute('role', 'button');
      page.setAttribute('aria-haspopup', 'dialog');
      page.setAttribute('aria-label', 'Enlarge ' + (page.querySelector('img')?.alt || 'sample page'));
    });
  }
  function openSamplePage(page) {
    if (document.querySelector('.tb-sample-lightbox')) return;
    const pages = Array.from(page.closest('[data-book-track]').querySelectorAll('.lw-sample-book__page'));
    let index = pages.indexOf(page);
    const dialog = document.createElement('dialog');
    dialog.className = 'tb-sample-lightbox';
    dialog.setAttribute('aria-label', 'Sample book enlarged pages');
    dialog.innerHTML = '<div class="tb-sample-lightbox__toolbar"><button type="button" data-sample-prev aria-label="Previous page">←</button><span data-sample-count aria-live="polite"></span><button type="button" data-sample-next aria-label="Next page">→</button><button type="button" class="tb-sample-lightbox__close" data-sample-close aria-label="Close enlarged view">×</button></div><img class="tb-sample-lightbox__image" alt="">';
    const image = dialog.querySelector('img');
    const previous = dialog.querySelector('[data-sample-prev]');
    const next = dialog.querySelector('[data-sample-next]');
    function show() {
      const original = pages[index].querySelector('img');
      image.src = original.currentSrc || original.src;
      image.alt = original.alt;
      dialog.querySelector('[data-sample-count]').textContent = 'Page ' + (index + 1) + ' of ' + pages.length;
      previous.disabled = index === 0;
      next.disabled = index === pages.length - 1;
    }
    let turning = false;
    let turnTimer;
    function move(step) {
      const target = Math.max(0, Math.min(pages.length - 1, index + step));
      if (turning || target === index) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { index = target; show(); return; }
      turning = true;
      image.style.transition = 'opacity 140ms ease, transform 140ms ease';
      image.style.opacity = '0';
      image.style.transform = 'translateX(' + (step > 0 ? '-18px' : '18px') + ')';
      turnTimer = setTimeout(function () {
        if (!dialog.open) return;
        index = target;
        image.style.transition = 'none';
        image.style.transform = 'translateX(' + (step > 0 ? '18px' : '-18px') + ')';
        show();
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (!dialog.open) return;
          image.style.transition = 'opacity 200ms ease, transform 200ms ease';
          image.style.opacity = '1';
          image.style.transform = 'translateX(0)';
          turnTimer = setTimeout(function () { turning = false; }, 200);
        }); });
      }, 140);
    }
    // Fetch the neighboring page ahead of the turn to avoid a blank frame.
    function preloadNeighbors() {
      [index - 1, index + 1].forEach(function (number) {
        const original = pages[number]?.querySelector('img');
        if (original) { const preload = new Image(); preload.src = original.currentSrc || original.src; }
      });
    }
    image.addEventListener('load', preloadNeighbors);
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    dialog.querySelector('[data-sample-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
    });
    let swipeStart = null;
    let ignoreClickUntil = 0;
    image.style.cursor = 'pointer';
    image.addEventListener('click', function (event) {
      if (Date.now() < ignoreClickUntil) return;
      const bounds = image.getBoundingClientRect();
      move(event.clientX < bounds.left + bounds.width / 2 ? -1 : 1);
    });
    image.addEventListener('touchstart', function (event) {
      swipeStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    image.addEventListener('touchend', function (event) {
      if (!swipeStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - swipeStart.x;
      const dy = event.changedTouches[0].clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) { ignoreClickUntil = Date.now() + 500; move(dx < 0 ? 1 : -1); }
    }, { passive: true });
    image.addEventListener('touchcancel', function () { swipeStart = null; }, { passive: true });
    const previousOverflow = document.body.style.overflow;
    dialog.addEventListener('close', function () { clearTimeout(turnTimer); document.body.style.overflow = previousOverflow; dialog.remove(); if (page.isConnected) page.focus({ preventScroll: true }); }, { once: true });
    document.body.append(dialog);
    show();
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-sample-close]').focus();
  }
  document.addEventListener('click', function (event) {
    const page = event.target.closest('.lw-sample-book__page');
    if (page) { event.preventDefault(); openSamplePage(page); }
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.lw-sample-book__page')) { event.preventDefault(); openSamplePage(event.target); }
  });
  const observer = new MutationObserver(makeSamplePagesClickable);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  makeSamplePagesClickable();
})();
